import React, { useState } from "react";
import OTPInput from "react-otp-input";

const OtpMobile = ({
  id_R,
  otpMobileOpen,
  handleCloseMobileOtp,
  customerEditDetails,
  setCustomerEditDetails,
}) => {
  const [otp, setOtp] = useState("");

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };
  return (
    <>
      <div
        id={id_R}
        className={`${
          otpMobileOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow max-w-[100%] mx-auto w-[55vw]">
            <div
              onClick={handleCloseMobileOtp}
              className="absolute top-[5px] right-[10px] cursor-pointer text-[24px] flex items-center justify-center"
            >
              X
            </div>
            <div className="p-[20px]">
              <div className="flex items-center mb-[30px]">
                <p className="text-[20px] font-bold text-[#000]">
                  Enter and verify customer new phone number
                </p>
              </div>
              <p className="text-[#000] w-[80%] text-[15px] mb-[20px]">
                Kindly share customer’s primary phone number for the
                verification process. An OTP is sent to the phone number entered
                to verify the phone number. Enter the OTP to complete.
              </p>
              <div className="flex flex-col justify-around h-[400px] mb-[20px]">
                <div className="flex w-[70%] flex-col">
                  <label htmlFor="firstname" className="mb-[20px]">
                    Phone Number
                  </label>
                  <div className="flex items-center gap-[10px]">
                    <input
                      type="text"
                      value={customerEditDetails.mobile}
                      onChange={(e) =>
                        setCustomerEditDetails((prev) => ({
                          ...prev,
                          mobile: e.target.value,
                        }))
                      }
                      className="w-[60%] h-[45px] px-[10px] border-[1px] border-[#9A9A9A] focus:outline-none"
                    />
                    {/* <button className="h-[45px] text-white font-[500] px-[16px] bg-[#17C6C6] rounded-[5px]">
                      Verify phone number
                    </button> */}
                  </div>
                </div>
                <div className="flex flex-col mt-2">
                  <label htmlFor="firstname" className="mb-[20px]">
                    Phone number verification OTP
                  </label>
                  <div>
                    <OTPInput
                      value={otp}
                      onChange={handleOtpChange}
                      numInputs={6}
                      onPaste={true}
                      renderInput={(props) => (
                        <input
                          {...props}
                          style={{ width: "45px", height: "45px" }}
                        />
                      )}
                      renderSeparator={<span className="mx-2" />}
                      inputStyle="bg-white text-[20px] text-center text-[24px] text-[#000] border-[1px] border-[#000] rounded-[5px]"
                    />
                  </div>
                </div>
              </div>
              <div className="mt-[20px]">
                <button
                  onClick={handleCloseMobileOtp}
                  className="bg-[#D9D9D9] h-[50px] px-[20px] rounded-[5px]"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpMobile;
